import React from "react";
import Secondary_banner from '../images/Secondary/Banner.png'
import Card_1 from '../images/Secondary/Card_1.png'
import Card_2 from '../images/Secondary/Card_2.png'
import Icon_1 from "../images/Secondary/Icon_1.png"
import Icon_2 from "../images/Secondary/Icon_2.png"
import Icon_3 from "../images/Secondary/Icon_3.png"
import Icon_4 from "../images/Secondary/Icon_4.png"


// Components
import Whyus from '../Card-Components/Whyus'
import Chatwithus from "../Components/chatwithus"
import Trends from "../Components/Trends"
import Milestone from "../Components/Milestone";


function Secondary () {

    const BrokerageContent =[
        {
            heading : "Get Professional help in home search",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },
        {
            heading : "Track your home value",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },
        {
            heading : "Get offers for your home",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },
        {
            heading : "Get Professional help in home search",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },
        {
            heading : "Track your home value",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },
        {
            heading : "Get offers for your home",
            content : "Lorem ipsum dolor sit amet consectetur. Tortor scelerisque eget maecenas nullam tellus risus nisl amet eget. Elementum est at purus faucibus.",

        },

    ]

    const chooseus = [
        {
            src:Icon_1,
            alt: "Simplicity",
            heading:"Token Scheduling",
            sub_heading:"Token scheduling at Sub registrar office based on Client convenience.",

        },
        {
            src:Icon_2,
            alt: "Expertise",
            heading:"Document Requried", 
            sub_heading:"Physical printouts of the Documents in the required Stamp paper.",

        },
        {
            src:Icon_3,
            alt: "Visibility",
            heading:"Registration Payment",
            sub_heading:"Payment of registration fees at the time of registration.",

        },
        {
            src:Icon_4,
            alt: "Save Time",
            heading:"Delivery",
            sub_heading:"Registered document handover at the Client’s place based on their convenience.",

        },
    ]

    return (
    <>
        <img className="w-full h-[300px] sm:h-fit lg:h-[650px] object-cover" src={Secondary_banner} alt="banner" />
        
         {/*Services */}
         <div className="font-[Merriweather] max-w-7xl mx-auto px-6 my-20 text-center text-black">
            <h2 className="heading" data-ao s="fade-up">Service</h2>
            <p className="service-description"data-aos="fade-up" data-aos-duration="1100">Lorem ipsum dolor sit amet consectetur. Sit etiam facilisis mollis elit senectus in. Arcu eros ut tellus sed lacus porta. Id in sit massa tristique nisl augue id. Mauris et sollicitudin mauris arcu proin. Placerat mattis mauris arcu massa eget eu sed massa. </p>
        </div>

        {/* Brokerage */}

        <div className="brokerage-background lg:!h-[594px] font-[Merriweather] px-4 py-10 sm:px-0">
            <div className="max-w-7xl mx-auto text-center">
                <h2 className="subheading py-16" data-ao s="fade-up">Brokerage</h2>
                
                <div className="flex flex-wrap justify-center gap-x-[75px]">
                    <div className="font-[lato] w-[450px] h-[545px] bg-white rounded-[16px] mt-10">
                        <h2 className="pt-14 text-[28px] font-semibold sm:text-[32px]">Buy Brokerage</h2>
                        <p className="max-w-[210px] mx-auto text-[16px] text-[#5F5D5E] mt-3 sm:mt-5">Lorem ipsum dolor sit amet consectetur. Tortor scelerisque</p>
                        <img className="mt-[41px]" src={Card_1} alt="Card" />
                    </div>
                    <div className="font-[lato] w-[450px] h-[545px] bg-white rounded-[16px] mt-10">
                        <h2 className="pt-14 text-[28px] font-semibold sm:text-[32px]">Sell Brokerage</h2>
                        <p className="max-w-[210px] mx-auto text-[16px] text-[#5F5D5E] mt-3 sm:mt-5">Lorem ipsum dolor sit amet consectetur. Tortor scelerisque</p>
                        <img className="mt-[41px]" src={Card_2} alt="Card" />
                    </div>
                </div>
            </div>
        </div>
        {/* Brokerage content */}
        <div className="font-[lato] mt-20 lg:mt-[320px] mb-[80px] px-4 sm:px-0">
            
            <div className="max-w-[1231px] mx-auto flex flex-wrap justify-between gap-y-4">
                {
                BrokerageContent.map((item) =>{
                    return(
                        <div className="w-[399px] h-[227px] border border-[#C1C1C1] p-[28px] rounded-[8px] mx-auto">
                            <h2 className="text-[20px] font-semibold">{item.heading}</h2>
                            <p className="text-[17px] text-[#5F5D5E] mt-4">{item.content}</p>
                        </div>
                    )
                })}
            </div>

        </div>

        {/* How it works */}
        <div className="mt-10 pb-[125px] max-w-[1236px] mx-auto bg-grey font-[lato]" data-aos="fade-up">
            <h2 className="font-[merriweather] text-[52px] text-center font-[400] leading-[58px] tracking-[1px] pt-[90px]" data-aos="fade-up">How it works</h2>
            <div className="max-w-[1100px] mx-auto flex flex-wrap justify-between mt-[35px] md:mt-[62px] px-2" data-aos="fade-up">
                {
                chooseus.map((items) =>{
                    return(
                        <div className="font-[lato] w-[280px] h-[315px] bg-white text-center border-2 border-[#E3E4E4] rounded-[8px] shadow-xl shadow-[#E6E8E9] mx-auto mt-10 pt-[28px] px-[23px] sm:w-[236px] lg:mt-0 transition ease-in-out duration-[650ms] hover:scale-[0.95] cursor-pointer">
                            <img className="w-[85px] h-[85px] mx-auto sm:w-[93px] sm:h-[93px]" src={items.src} alt={items.alt} />
                            <div className="mt-[26px]">
                                <h2 className="text-[25px] font-semibold font-[400] sm:text-[18px]">{items.heading}</h2>
                                <h2 className="text-[16px] text-[#5F5D5E] sm:text-[17px] font-[400] mt-5">{items.sub_heading}</h2>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
        
        <Milestone />

        <Whyus />

        <Trends />

        <Chatwithus />
    </>
    );
}

export default Secondary;